/* eslint-disable linebreak-style */
const ProductContextDefault = {
  product: null,
  setProduct: () => {},
  isLoading: true,
  setIsLoading: () => {},
}

export default ProductContextDefault
